<template>
  <span v-if="Number.isInteger(executedQuantity)">
    {{ executedQuantity }}
<!-- todo(egor): remove edit form-->
<!--    <v-icon v-if="editable" small @click="handleShowFormClick">edit</v-icon>-->

    <v-layout row justify-center v-if="showForm">
      <v-dialog v-model="showForm" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">Изменение количества исполненной услуги</v-card-title>

          <v-card-text>
                        <number-delta-input
                          v-model="quantityChange"
                          label="Qty"
                          :current-value="executedQuantity"
                          :minValue="0"
                          :max-value="150"/>
            <v-textarea
              label="Комментарий"
              v-model="comment"
            />
          </v-card-text>

          <v-card-actions>
            <v-spacer/>
            <v-btn
              color="gray darken-1"
              flat="flat"
              :loading="requestInProgress"
              @click="handleCloseFormClick">
              Close
            </v-btn>

            <v-btn
              color="primary darken-1"
              flat="flat"
              :loading="requestInProgress"
              :disabled="this.quantityChange === 0"
              @click="handleSendFormClick">
              Edit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </span>
  <span v-else>
    -
  </span>
</template>

<script>
    import {caseServiceService, notificationService} from '../../../application'
    import NumberDeltaInput from '../../Ui/NumberDeltaInput'

    export default {
        name: 'executed-service-quantity',
        components: {
            NumberDeltaInput
        },
        props: {
            caseId: {
                type: String,
                required: true
            },
            serviceId: {
                type: String,
                required: true
            },
            executedQuantity: {
                type: Number
            },
            editable: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                showForm: false,
                quantityChange: 0,
                comment: '',
                requestInProgress: false
            }
        },
        computed: {},
        methods: {
            handleShowFormClick() {
                this.showForm = true
            },
            handleCloseFormClick() {
                this.resetForm()
            },
            handleSendFormClick() {
                if (this.requestInProgress || this.quantityChange === 0) {
                    return
                }

                this.requestInProgress = true;
                caseServiceService.changeExecutedServicesQuantity({
                    caseId: this.caseId,
                    serviceId: this.serviceId,
                    quantityChange: this.quantityChange,
                    metadata: {
                        comment: this.comment
                    }
                })
                    .then((response) => {
                        this.$emit('executedQuantityChanged', {newQuantity: response.newQuantity});
                        this.resetForm();
                        notificationService.success('Изменения сохранены')
                    })
                    .catch(e => {
                        notificationService.error('Не удалось завершить операцию');
                        throw e
                    })
                    .finally(() => {
                        this.requestInProgress = false
                    })
            },
            resetForm() {
                this.showForm = false;
                this.quantityChange = 1;
                this.comment = ''
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Sales/case/ExecutedServiceQuantity.vue